import { BaseAnalyticsModule } from './BaseAnalyticsModule';
import { AnalyticsEventTypes } from '../models';

export class EmptyModule extends BaseAnalyticsModule {
  type: AnalyticsEventTypes = AnalyticsEventTypes.V1_EVENT;
}
